import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

function Layout() {
  return (
    <div className="app-container">
      <Header />
      
      <div className="main-content">
        <Sidebar />
        <div className="content-area">
          <Outlet />
        </div>
      </div>
      
      <nav className="mobile-nav">
        <div className="mobile-nav-items">
          <button className="mobile-nav-item active" data-screen="courses">
            <span>🏫</span>
            <span>Courses</span>
          </button>
          <button className="mobile-nav-item" data-screen="dashboard">
            <span>📊</span>
            <span>Dashboard</span>
          </button>
          {/* Commented out - Users Dashboard accessible only via direct URL: /users-dashboard?id=<ID> */}
          {/* <button className="mobile-nav-item" data-screen="users-dashboard">
            <span>👥</span>
            <span>Users</span>
          </button> */}
          <button className="mobile-nav-item" data-screen="chat">
            <span>💬</span>
            <span>Chat</span>
          </button>
          <button className="mobile-nav-item" data-screen="upload">
            <span>📤</span>
            <span>Upload</span>
          </button>
          <button className="mobile-nav-item" data-screen="quiz">
            <span>📝</span>
            <span>Quiz</span>
          </button>
        </div>
      </nav>
    </div>
  );
}

export default Layout;
